export default __webpack_public_path__ + "static/media/img1LightEn.ab4e7985.png";